import { Button } from "components/Button/Button";
import { Form } from "components/Form/components/Form/Form";
import { getInitialModal } from "containers/Resources/screens/ResourcesSingle/components/GitAction/GitAction";

export const showEmptyCommitModal = (title?: string) => {
    return new Promise((resolve, reject) => {
        const modal = getInitialModal();
        const closeModal = () => modal.destroy();
        const content = (
            <>
                <Form.Row>{title ?? "Nothing to commit, working tree clean."}</Form.Row>
                <div style={{ marginLeft: "auto" }}>
                    <Button variation="primary" label={"Ok"} onClick={() => closeModal()} />
                </div>
            </>
        );
        modal.update((previousConfig) => ({
            ...previousConfig,
            content,
        }));
    });
};
